import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faQuestionCircle, faFilm, faPlayCircle, faEnvelope, faColumns, faCog, faFilter, faChartArea, faUser, faSignOutAlt, faPercent, faTimes, faDollarSign
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faQuestionCircle, faFilm, faPlayCircle, faEnvelope, faColumns, faCog, faFilter, faChartArea, faUser, faSignOutAlt, faPercent, faTimes, faDollarSign
)

export default library
